import { createContext, PropsWithChildren } from "react";

type DropdownMenuContextValue = {
  open?: boolean;
  onOpenChange?(open: boolean): void;
  modal?: boolean;
};

export const DropdownContext = createContext<
  DropdownMenuContextValue | undefined
>(undefined);

export const DropdownProvider = ({
  children,
  ...rest
}: PropsWithChildren<DropdownMenuContextValue>) => {
  return (
    <DropdownContext.Provider value={rest}>{children}</DropdownContext.Provider>
  );
};
